import { faListCheck } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { DollarSign, Search, Truck } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { getHeaderByTdhId } from "../../api/documentManagementApi";
import { getDocumentByOpeAndRef } from "../../api/documentUpload";
import {
  getTransportChargeReview,
  searchDownloadTransporterChargesExcel,
  searchDownloadTransporterChargesPdf,
  searchTransporterCharges,
  searchTransporterInvoices,
  TransporterChargesById
} from "../../api/finance/transporter-invoice";
import { getOtherRefSearchDropdown } from "../../api/keyvalue";
import AnimatedIcon from "../../components/AnimatedIcon";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import Tab from "../../components/Tab";
import TransporterChargesReview from "../../components/finance/TransporterInvoice/TransporterChargesReview";
import TransporterInvoiceAdd from "../../components/finance/TransporterInvoice/TransporterInvoiceAdd";
import TransporterInvoiceDocument from "../../components/finance/TransporterInvoice/TransporterInvoiceDocument";
import ActionMenu from "../../components/input/ActionMenu";
import Button from "../../components/input/Button";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import IconButtonRenderer from "../../components/renderer/IconButtonRenderer";
import {
  DateOnlyCellRenderer,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { formatToDateOnlyFromJsonDate } from "../../dateConfig";
import { errorMessageToast } from "../../helper";
import useUserCompany from "../../hooks/useUserCompany";
import { errorActions } from "../../store/error-slice";
import AddTransporterCharges from "./AddTransporterCharges";

const TransporterInvoice = () => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);

  const userCompany = useUserCompany();

  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(true);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [transporter, setTransporter] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [results, setResults] = useState([]);
  const [reloadDates, setReloadDates] = useState(true);
  const [searchClicked, setSearchClicked] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [tdhId, setTdhId] = useState("");
  const [supplierInvoice, setSupplierInvoice] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [detailCharges, setDetailCharges] = useState(null);
  const [headerCharges, setHeaderCharges] = useState(null);
  const [transporterChg, setTransporterChg] = useState(null);
  const [fromDateChg, setFromDateChg] = useState(null);
  const [toDateChg, setToDateChg] = useState(null);
  const [resultsChg, setResultsChg] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [searchClickedChg, setSearchClickedChg] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [resetChargeSearchFields, setResetChargeSearchFields] = useState(false);
  const [isopenReviewModal, setIsOpenReviewModal] = useState(false);
  const reviewModalRef = useRef(null);
  const [chargeReview, setChargeReview] = useState([]);
  const [reviewLoading, setReviewLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [currency, setCurrency] = useState(
    userCompany ? userCompany.comCurrency : null,
  );
  const [jobIds, setJobIds] = useState([]);

  const dispatch = useDispatch();

  const gridRef = useRef(null);
  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    const selectedJobIds = selectedData.map(row => row.jobId);
    setJobIds(selectedJobIds);
    console.log("selectedData",selectedJobIds);
  }

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
      setFromDateChg(formattedWeekAgo);
      setToDateChg(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const onSearch = async () => {
    try {
      setActiveAccordion(false);
      setSearchClicked(true);
      setIsSearchLoading(true);
      const data = await searchTransporterInvoices({
        transporter,
        fromDate,
        toDate,
      });
      if (data && data.length > 0) {
        setResults(
          data.map((tpi) => ({
            ...tpi,
            fromDateFormatted: formatToDateOnlyFromJsonDate(tpi.tpiFromDate),
            toDateFormatted: formatToDateOnlyFromJsonDate(tpi.tpiToDate),
          })),
        );
      } else {
        setResults([]);
      }
      setIsSearchLoading(false);
    } catch (e) {
      errorMessageToast(e);
    }
  };

  useEffect(() => {
    setCurrency(userCompany ? userCompany.comCurrency : null);
  }, [userCompany]);

  useEffect(() => {
    if (!reviewModalRef.current) return;

    if (isopenReviewModal) {
      reviewModalRef.current.showModal();
    } else {
      reviewModalRef.current.close();
    }
  }, [isopenReviewModal]);

  const getChargeReview = async (row) => {
    try {
      setReviewLoading(true);
      const chargeReviewRequest = {
        jobId: row.jobId,
        revcosId: 2,
        currency: currency,
      };
      console.log("Charge Review Request", chargeReviewRequest);
      setDrawerOpen(false);
      const [response, chargeData] = await Promise.all([
        getTransportChargeReview(chargeReviewRequest),
        TransporterChargesById(row.jobId),
      ]);

      setChargeReview(response || []);
      setHeaderCharges(chargeData.headerResponse);
      setDetailCharges(chargeData.detailResponse);

      setIsOpenReviewModal(true);
    } catch (e) {
      errorMessageToast(e);
    }
    setReviewLoading(false);
  };

  const onReset = () => {
    setSearchClicked(false);
    setResults([]);
    setTransporter(null);
    setFromDate(null);
    setToDate(null);
    setReloadDates(true);
    setResetSearchFields((prev) => !prev);
  };

  const handleEditClick = async (tdhId, rowData) => {
    try {
      setEditMode(true);
      setSelectedInvoice(rowData);

      const headerData = await getHeaderByTdhId(tdhId);
      setSupplierInvoice(headerData);

      const documentData = await getDocumentByOpeAndRef(16, tdhId);
      setDocuments(documentData);

      setTdhId(tdhId);
      setDrawerOpen(true);
    } catch (e) {
      errorMessageToast(e);
    }
  };

  const onSearchCharge = async (e) => {
    e.preventDefault();
    try {
      const newErrors = {};
      if (!transporterChg) {
        newErrors.transporter = "Transporter is required";
        setErrors(newErrors);
      } else {
        setActiveAccordion(false);
        setSearchClickedChg(true);
        setIsSearchLoading(true);

        const data = await searchTransporterCharges({
          transporterChg,
          fromDateChg,
          toDateChg,
          author: user.username,
          company: company,
        });
        if (data && data.length > 0) {
          setResultsChg(data);
        } else {
          setResultsChg([]);
        }
        setIsSearchLoading(false);
      }
    } catch (e) {
      errorMessageToast(e);
      setIsSearchLoading(false);
    }
  };

  const onSearchChargeDownload = async (e, param) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    try {
      const newErrors = {};
      if (!transporterChg) {
        newErrors.transporter = "Transporter is required";
        setErrors(newErrors);
      } else {
        setActiveAccordion(false);
        setSearchClickedChg(true);
        setIsSearchLoading(true);
        let excelBlob;
        let fileName;
        if (param === "pdf") {
          excelBlob = await searchDownloadTransporterChargesPdf({
            transporterChg,
            fromDateChg,
            toDateChg,
            author: user.username,
            company: company,
            jobIds: jobIds.length > 0 ? jobIds : null,
          });
          fileName = `REPORT OF TRANSPORTER CHARGES REPORT .pdf`;
        } else {
          excelBlob = await searchDownloadTransporterChargesExcel({
            transporterChg,
            fromDateChg,
            toDateChg,
            author: user.username,
            company: company,
            jobIds: jobIds.length > 0 ? jobIds : null,
          });
          fileName = `REPORT OF TRANSPORTER CHARGES REPORT .xlsx`;
        }

        const url = window.URL.createObjectURL(new Blob([excelBlob]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setIsSearchLoading(false);
      }
    } catch (e) {
      errorMessageToast(e);
      setIsSearchLoading(false);
    }
  };
  const onResetCharge = () => {
    setSearchClickedChg(false);
    setResultsChg([]);
    setTransporterChg(null);
    setFromDateChg(null);
    setToDateChg(null);
    setReloadDates(true);
    setResetChargeSearchFields(true);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setEditMode(false);
    setSupplierInvoice([]);
    setDocuments([]);
    setTdhId("");
    dispatch(errorActions.clearSupplierInvoiceError());
  };

  const handleReportAdd = async (selectedType) => {
    if (!selectedType) return;

    if (selectedType.id === 1) {
      await onSearchChargeDownload(null, "pdf");
    }

    if (selectedType.id === 2) {
      await onSearchChargeDownload(null, "excel");
    }
  };
  const reportOpt = [
    {
      id: 1,
      value: 1,
      text: "Generate PDF",
    },
    {
      id: 2,
      value: 2,
      text: "Generate EXCEL",
    },
  ];
  const modalRef = useRef(null);

  return (
    <>
      <Modal ref={modalRef} minWidth={"60vw"} minHeight={"400px"}>
        <TransporterInvoiceDocument tdhId={currentId} />
      </Modal>

      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <Tab
            Icon={Truck}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Transporter Invoice"
          />
          <Tab
            Icon={DollarSign}
            onClick={() => {
              setTab(2);
            }}
            active={tab === 2}
            label="Transporter Charges"
          />
        </div>
        {tab === 1 && (
          <Button
            template="drawerOpen"
            onClick={handleDrawerOpen}
            editMode={false}
          />
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion ? "active" : ""}`}
            onClick={() => setActiveAccordion((prev) => !prev)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div className={`content ${activeAccordion ? "active" : ""}`}>
            <form className="ui form">
              <h4 className="ui dividing header">Transporter Invoice</h4>
              <div className="three fields">
                <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => setTransporter(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 3
                      ? {
                          type: "user_stakeholder_all",
                          value: "Transporter",
                          param2: user.username,
                        }
                      : {
                          type: "stakeholder_type",
                          value: "transporter_all",
                        }
                  }
                  label="Transporter"
                />
                <Input
                  type="date"
                  label="From Date"
                  name="fromDate"
                  max={toDate ?? null}
                  value={fromDate ?? ""}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                  }}
                />
                <Input
                  label="To Date"
                  type="date"
                  name="toDate"
                  min={fromDate}
                  value={toDate ?? ""}
                  disabled={!fromDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                  }}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button template="search" onClick={onSearch} />
                  <Button template="searchReset" onClick={onReset} />
                </div>
              </div>
            </form>
          </div>
        </div>
        {searchClicked && (
          <>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                showDownloadButton={true}
                downloadParam={""}
                downloadAction="Transporter Invoice Download"
                reportName="transporter_invoices.csv"
                downloadOnlySelected={false}
                content={results}
                config={[
                  {
                    headerName: "Transporter",
                    field: "tpiTransporterName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "From Date",
                    field: "fromDateFormatted",
                  },
                  {
                    headerName: "To Date",
                    field: "toDateFormatted",
                  },
                  {
                    headerName: "Vehicle",
                    field: "tpiVehicleNo",
                  },
                  {
                    headerName: "Requests",
                    field: "tpiRequests",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Documents",
                    field: "tpiCountLabel",
                  },
                  {
                    headerName: "Documents Upload Date",
                    field: "docUploadDate",
                    cellRenderer: DateOnlyCellRenderer,
                  },
                  {
                    headerName: "Edit",
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: (e) => {
                        handleEditClick(params.data.tpiId, params.data);
                        setEditMode(true);
                      },
                      label: "Edit",
                    }),
                  },
                ]}
                onCellDoubleClicked={(props) => {
                  if (props.data) {
                    const { tpiId, tpiDocCount } = props.data;
                    if (tpiDocCount > 0) {
                      setCurrentId(tpiId);
                      modalRef.current?.showModal();
                    }
                  }
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion ? "active" : ""}`}
            onClick={() => setActiveAccordion(!activeAccordion)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div className={`content ${activeAccordion ? "active" : ""}`}>
            <form className="ui form">
              <h4 className="ui dividing header">Transporter Charges</h4>
              <div className="three fields">
                <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetChargeSearchFields}
                  setReset={setResetChargeSearchFields}
                  clearable={true}
                  onClear={() => {
                    setTransporterChg(null);
                  }}
                  checkCount={true}
                  value={transporterChg}
                  error={errors.transporter}
                  resetError={(errors) =>
                    setErrors({ ...errors, transporter: undefined })
                  }
                  onResultSelect={(data) => setTransporterChg(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 3
                      ? {
                          type: "user_stakeholder_all",
                          value: "Transporter",
                          param2: user.username,
                        }
                      : {
                          type: "stakeholder_type",
                          value: "transporter_all",
                        }
                  }
                  multiGrid={true}
                  label="Transporter"
                  required={true}
                />
                <Input
                  type="date"
                  label="From Date"
                  name="fromDate"
                  max={toDateChg ?? null}
                  value={fromDateChg ?? ""}
                  onChange={(e) => {
                    setFromDateChg(e.target.value);
                  }}
                  required={true}
                />
                <Input
                  label="To Date"
                  type="date"
                  name="toDate"
                  min={fromDateChg}
                  value={toDateChg ?? ""}
                  disabled={!fromDateChg}
                  onChange={(e) => {
                    setToDateChg(e.target.value);
                  }}
                  required={true}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  {/*<Button*/}
                  {/*  template="generateReport"*/}
                  {/*  label="Generate PDF"*/}
                  {/*  onClick={(e) => {*/}
                  {/*    onSearchChargeDownload(e, "pdf");*/}
                  {/*  }}*/}
                  {/*/>*/}
                  {/*<Button*/}
                  {/*  template="generateReport"*/}
                  {/*  label="Generate EXCEL"*/}
                  {/*  onClick={(e) => {*/}
                  {/*    onSearchChargeDownload(e, "excel");*/}
                  {/*  }}*/}
                  {/*/>*/}
                  <ActionMenu
                    title="Action"
                    options={reportOpt}
                    onChangeHandler={handleReportAdd}
                    actionMenuStyle={{ width: "8vw", marginRight: "10px" }}
                  />

                  <Button
                    template="search"
                    onClick={(e) => {
                      onSearchCharge(e);
                    }}
                  />
                  <Button template="searchReset" onClick={onResetCharge} />
                </div>
              </div>
            </form>
          </div>
        </div>
        {searchClickedChg && (
          <>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                ref={gridRef}
                showDownloadButton={true}
                downloadParam={""}
                downloadAction="Transporter Charges Download"
                reportName="transporter_charges.csv"
                downloadOnlySelected={false}
                multiRowSelection={true}
                content={resultsChg}
                onSelectionChanged={handleSelectionChanged}
                gridOptions={{
                  getRowStyle: (params) => {
                    if (params.data?.hasCharge === "t") {
                      return { backgroundColor: "#ffe5e5" };
                    }
                    return null;
                  },
                }}
                config={[
                  {
                    headerName: "Transporter",
                    field: "transporterName",
                    cellRenderer: ResizableScrollingTextRenderer,
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                  },
                  {
                    headerName: "Job",
                    field: "jobCode",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Request",
                    field: "requestCode",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Vehicle",
                    field: "vehicleNo",
                  },
                  {
                    headerName: "Status",
                    field: "statusName",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    minWidth: 110,
                    width: 110,
                    field: "review",
                    filter: true,
                    cellStyle: { backgroundColor: "white" },
                    cellRenderer: IconButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        getChargeReview(params.data);
                      },
                      icon: (
                        <AnimatedIcon
                          icon={faListCheck}
                          color="black"
                          size="15px"
                          beatDuration="1s"
                        />
                      ),
                      style: { width: "70px", height: "30px" },
                    }),
                    pinned: "right",
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  if (props.data) {
                    const { jobId, tpiDocCount } = props.data;
                    const response = await TransporterChargesById(
                      props.data.jobId,
                    );
                    setDetailCharges(response.detailResponse);
                    setHeaderCharges(response.headerResponse);
                    setSelectedRow(props.data);
                    setEditMode(true);
                    setDrawerOpen(true);
                  }
                }}
              />
            )}
          </>
        )}
      </div>
      <SideDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          tab === 1 ? (
            editMode ? (
              <div className="drawer-header">
                <div
                  style={{
                    padding: "10px 16px",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  <h3>
                    {!editMode
                      ? "Add Transporter Invoice"
                      : `Invoice Code: ${selectedInvoice.tpiCode} `}
                  </h3>
                </div>
              </div>
            ) : null
          ) : (
            <div className="drawer-header">
              {!editMode && (
                <div style={{ padding: "10px 0 10px 0" }}>
                  {/* <h3>Add Transporter Charges To : {selectedRow?.jobCode}</h3> */}
                </div>
              )}

              {editMode && (
                <div style={{ padding: "10px 0 10px 0" }}>
                  {/* <h3>Edit Transporter Charges of : {selectedRow?.jobCode}</h3> */}
                </div>
              )}
            </div>
          )
        }
        body={
          tab === 1 ? (
            <TransporterInvoiceAdd
              editMode={editMode}
              handleDrawerClose={handleDrawerClose}
              tdhId={tdhId}
              currentValues={supplierInvoice}
              documents={documents}
            />
          ) : (
            <AddTransporterCharges
              jobInfo={selectedRow}
              editMode={editMode}
              handleDrawerClose={handleDrawerClose}
              detailChanges={detailCharges}
              headerChanges={headerCharges}
            />
          )
        }
        style={{ width: tab === 2 ? "90vw" : "60vw", boxShadow: "none" }}
      />
      <Modal
        ref={reviewModalRef}
        minWidth={"60vw"}
        minHeight={"400px"}
        onCloseCleanUp={() => setIsOpenReviewModal(false)}
        clickOutSide={false}
      >
        <div
          style={{
            width: "100%",
            padding: 0,
            margin: 0,
          }}
        >
          {reviewLoading ? (
            <LoadingSpinner />
          ) : (
            <TransporterChargesReview
              chargeReview={chargeReview}
              headerCharge={headerCharges}
              onApprovalSuccess={() => {
                setTimeout(() => {
                  setIsOpenReviewModal(false);
                  if (searchClickedChg) {
                    onSearchCharge({ preventDefault: () => {} });
                  }
                }, 1500);
              }}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default TransporterInvoice;
